import { Grid } from "@material-ui/core"
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { Text } from "sunrise-ui";
import { HeadLines } from "../Dashboard/Dashboard";
import ClientBillingGraph from "./ClientBillingReport/ClientBillingGraph";
import ClientBillingTable from "./ClientBillingReport/ClientBillingTable";
import { getOverallFinancialDetails } from "../../redux/reducers/projectReducers";

const ClientBillingReport = () => {
    const dispatch = useDispatch<AppDispatch>();
    const profileData = useSelector((state: any) => state.PROFILE.profileDetails);
    const overallFinancialData = useSelector((state: any) => state.PROJECT.overallFinancialData);

//-----Rs. to Crore conversion----
const numToCr = (value: any) => {
    let val = Math.abs(value)
    if (val >= 10000000) {
      val = +(val / 10000000).toFixed(2);
    }
    else { val = +(val / 10000000).toFixed(2);
    }
    return val;
  }

  useEffect(() => {
    if(profileData){
      dispatch(
        getOverallFinancialDetails({
            endPoint: `project-finance/get-overall-financial`
        })
      );
    }
  }, [dispatch, profileData])
    return (
        <Grid spacing={2}>
            <Grid item xs={12}>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt1"
                >
                    <span className="fw500">Client Billing (Crores)</span>
                </Text>
            </Grid>
            <Grid className="flex_start mt1">
                <HeadLines
                    label="Overall Work Done till date"
                    icon={"approved"}
                    value={numToCr(overallFinancialData?.[0]?.workDone)}
                    fontSize={18}
                />
                <HeadLines
                    label="Billing Done till date"
                    icon={"totalProjectIcon"}
                    value={numToCr(overallFinancialData?.[0]?.billingDone)}
                    fontSize={18}
                />
                <HeadLines
                    label="Payment Received till date"
                    icon={"cash"}
                    value={numToCr(overallFinancialData?.[0]?.paymentReceived)}
                    fontSize={18}
                />
            </Grid>
            <ClientBillingTable />
            <ClientBillingGraph />
        </Grid >
    )
}

export default ClientBillingReport;